import HouseTypeViewModel from './HouseTypeViewModel';
import eventEnable from '../core/eventEnable';
export default class HouseTypesViewModel{
	constructor(plotsArray){
		eventEnable(this);
		this._dispatchSelectedChanged = this._dispatchSelectedChanged.bind(this);
		const houseTypesForPlots=[];
		plotsArray.forEach(plot=>{
			if(plot.affordable)return;
			if(houseTypesForPlots.indexOf(plot.houseType)<0)
				houseTypesForPlots.push(plot.houseType);
		});
		
		const mapHouseTypeNameToHouseTypes = new Map();
		houseTypesForPlots.forEach(houseType=>{
			let listOfHouseTypesForName = mapHouseTypeNameToHouseTypes.get(houseType.name);
			if(listOfHouseTypesForName===undefined||listOfHouseTypesForName===null){
				listOfHouseTypesForName=[];
				mapHouseTypeNameToHouseTypes.set(houseType.name, listOfHouseTypesForName);
			}
			listOfHouseTypesForName.push(houseType);
		});
		const houseTypeLists = Array.from(mapHouseTypeNameToHouseTypes.values());
		this._entries = houseTypeLists.map(houseTypeList=>{
			const houseTypeViewModel = new HouseTypeViewModel(houseTypeList);
			houseTypeViewModel.addEventListener('selectedchanged', this._dispatchSelectedChanged);
			return houseTypeViewModel;
		});
	}
	get entries(){
		return this._entries;
	}
	_dispatchSelectedChanged(e){
		this.dispatchEvent(e);
	}
}